import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import uuid from "react-uuid";
import client from "../images/client.png";
import rightArrow from "../images/right-arrow.png";
import website from "../images/web.png";
const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch("/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <div id="projects" className="projects">
      <div className="section-heading">
        <h4>Projects</h4>
      </div>
      <div className="projects-wrapper">
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            <div className="project-banner">
              <img src={project.banner} alt="" />
            </div>
            <div className="project-details">
              <div className="left-content">
                <div className="name-link-area">
                  <p>{project.name}</p>
                  <ul>
                    <li title="Live site">
                      <a href={project.livesite} target="_blank">
                        {" "}
                        <img src={website} alt="" />{" "}
                      </a>
                    </li>

                    {project?.clientGithub?.length > 0 && (
                      <li title="Github Client">
                        <a href={project.clientGithub} target="_blank">
                          {" "}
                          <img src={client} alt="" />{" "}
                        </a>
                      </li>
                    )}

                    {project?.serverGithub?.length > 0 && (
                      <li title="Github Server">
                        <a href={project.serverGithub} target="_blank">
                          {" "}
                          <img src={client} alt="" />{" "}
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="view-details-area">
                  <Link to={`/project/${project.id}`}>
                    <span>More Details</span>
                    <img src={rightArrow} alt="rightArrow" />
                  </Link>
                </div>
              </div>
              <div className="right-content">
                <div className="tech">
                  <ul>
                    {project.tech.slice(0, 6).map((singleTech) => (
                      <li key={uuid()}>{singleTech}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
